/**
 * **************************************************************************
 * Dashboard - error-diagnostics service file
 *
 * Defines all http api calls required in error-diagnostics page
 * Calls server apis and returns data to components
 * **************************************************************************
 */
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '@app/services/api.service';

@Injectable({
  providedIn: 'root'
})
export class ErrorDiagnosticsService {

  /****************** Variable declaration ******************/
  headers = new HttpHeaders({ "isLoader": "false" })

  /* define required apis */
  public mlGroupUrl = this.apiService.KPID_URL + this.apiService.DASHBOARD_APIS.ERROR_DIADNOSTICS.ML_GROUP;

  //user endpoint
  public userDetailsUrl = `${this.apiService.KPID_URL}${this.apiService.USER.USER}`;

  /**
   * Constructor
   * @param httpClient 
   * @param apiService 
   */
  constructor(
    private httpClient: HttpClient,
    private apiService: ApiService
  ) { }

  /**
   * Retrieve the error group details
   * @returns
   */
  getErrorGroupDetails(): Observable<any> {
    const url = this.mlGroupUrl + this.apiService.DASHBOARD_APIS.ERROR_DIADNOSTICS.GET_GROUP_ERROR_DETAILS;
    let response = this.httpClient.get(url);
    return response;
  }

  /**
   * Retrieve error cluster details
   * @param grpName
   * @param weekNum
   * @returns
   */
  getErrorClusterDetails(grpName: string, weekNum: number) {
    const url = this.mlGroupUrl + this.apiService.DASHBOARD_APIS.ERROR_DIADNOSTICS.GET_CLUSTER_DETAILS(grpName, weekNum);
    let response = this.httpClient.get(url);
    return response;
  }

  /**
   * get the error details
   * @param keyword pass the keyword
   * @returns 
   */
  getErrorDignosticUsers(keyword: number, weekNum: number) {
    const url = this.mlGroupUrl + this.apiService.DASHBOARD_APIS.ERROR_DIADNOSTICS.GET_ERROR_DETAILS(keyword, weekNum);
    let response = this.httpClient.get(url);
    return response;
  }

  /**
   * Get user details api
   * @param userId 
   */
  getUserProfile(userId: string): Observable<any> {
    let url = `${this.userDetailsUrl}${this.apiService.USER.USER_DETAILS(userId)}`
    let response = this.httpClient.get(url, { headers: this.headers });
    return response;
  }
}
